export default __webpack_public_path__ + "18eeeec283daeb03e6574b3f9f70b87a.svg";